export const stages = [
  "Work", //0
  "Rest", //1
  "Work", //2
  "Rest", //3
  "Work", //4
  "Relax", // 5
];

export const stageTimes = {
  Work: 25 * 60,
  Rest: 5 * 60,
  Relax: 15 * 60,
};
